import type { FC } from 'react';

import { MplButton } from './MplButton';
import { TMplButtonProps } from './types';

export const MplLinkButton: FC<TMplButtonProps> = ({ children, ...props }) => (
	<MplButton variant="pseudolink" size="small" {...props}>
		{children}
	</MplButton>
);
